import { webSocketsRepository } from 'repositories/WebSockets';
import WebSocketsService from './WebSocketsService';

export const webSocketsService = new WebSocketsService(webSocketsRepository);
